import { render, staticRenderFns } from "./UserSignatureFeet.vue?vue&type=template&id=48871ab0&scoped=true"
import script from "./UserSignatureFeet.vue?vue&type=script&lang=js"
export * from "./UserSignatureFeet.vue?vue&type=script&lang=js"
import style0 from "./UserSignatureFeet.vue?vue&type=style&index=0&id=48871ab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48871ab0",
  null
  
)

export default component.exports